import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { MessengerService } from 'src/app/_services/messenger.service';
import { ApiService } from 'src/app/_services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DOCUMENT } from '@angular/common';
import { ChatServiceService } from 'src/app/_services/chatService.service';
import { trigger, state, style, animate, transition } from '@angular/animations';


@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent implements OnInit {
  toggler: boolean = false;
  toggleDisplay: boolean = false;
  setMessage: string;
  toggleSpinner: boolean = false;
  @ViewChild('chatBox') private myScrollContainer: ElementRef;
  messages: Message[] = [

  ];
  // chatBoxWrapper
  constructor(private messenger: MessengerService, private api: ApiService, private spinner: NgxSpinnerService, public chatService: ChatServiceService, @Inject(DOCUMENT) document) { }

  scrollBottom(el: string) {

    setTimeout(() => {
      let element = document.getElementById(el);
      element.scrollIntoView();

      document.getElementById("chat").scrollTop -= 100;
     }, 500);

  }
  ngOnInit() {
    this.showSpinner()
  }
  initConversation(text: string) {
    this.messenger.createThread({ Id: '2' }).subscribe( next => {
      console.log('Token Added Successfully');
      this.createMessage(text);
    }, error => {
      console.log('Token Failed');
    });
  }
  createMessage(text: string) {
    this.toggleSpinner = true;
    let lang = localStorage.getItem('lang') || 'en'
    if(lang != 'en') {
      this.api.translate(text, 'en').subscribe(item => {

        this.messenger.getMessage({ content: item.message, isMapRequest: false }, this.messenger.messengerInfo.id.toString()).subscribe(data => {
          this.api.translate(data.content, lang).subscribe(r => {
            this.toggleSpinner = false;
            this.messages.push({
              message: r.message,
              isUser: true
            })
            // this.scrollBottom();
            let el = document.getElementById("chat")
            el.scrollTop =  -el.scrollHeight

          })
        })
      });
    }
    else {
      this.messenger.getMessage({ content: text, isMapRequest: false }, this.messenger.messengerInfo.id.toString()).subscribe(data => {
        console.log(data);
        this.toggleSpinner = false;
        this.messages.push({
          id: data.id,
          message: data.content,
          isUser: true
        })
        this.scrollBottom(data.id.toString());

      }, error => {
        console.log('Error loading Information');
      });
    }

  }
  showSpinner() {
    this.spinner.show();
    // setTimeout(() => {
    //   this.spinner.hide();
    // }, 5000);
  }
  toggle() {
    if(!this.toggleDisplay){
      this.chatService.openChatBot();
      // this.toggler = !this.toggler
    // this.toggleDisplay = !this.toggleDisplay;
    }

  }


  addMessage(item: any) {
   
    if(item.value.msg == undefined || item.value.msg == null || item.value.msg == "")
    {
      return
    }
    if(!this.messenger.messengerInfo)
      this.initConversation(item.value.msg)
    else
      this.createMessage(item.value.msg);

    this.messages.push({
      message: item.value.msg,
      isUser: false
    })




  }

  addMessageManual(msg: string) {
    if(!this.messenger.messengerInfo)
      this.initConversation(msg)
    else
      this.createMessage(msg);
  }

}

interface Message {
  id?: number;
  message: string,
  isUser: boolean
}
